/**
 * Project : workspace
 * File    : BusinessOrderListScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.order.list

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.commerce.feature.order.viewModel.OrderViewModel
import com.parmartechnologies.core.navigation.NavigationParam
import component.empty.EmptyData
import component.navigation.TopNavBar
import component.order.OrderBusinessCard
import navigation.AppNavigator
import theme.ThemeColor

/**
 * Represents the business order list screen class.
 */

class BusinessOrderListScreen{
    @Composable
    fun Content() {
        val businessViewModel = BusinessViewModel()
        val myBusiness = businessViewModel.myBusiness.collectAsState()
        val viewModel = OrderViewModel(myBusiness.value)

        val orders = viewModel.allOrders.collectAsState()
        val navigationParam = AppNavigator.shared().getNavigationParam()

        LaunchedEffect(key1 = Unit) {
            navigationParam.business = myBusiness.value
            navigationParam.selectedBusiness = myBusiness.value
            viewModel.loadOrders(navigationParam)
            // viewModel.retrieve()
        }
        Column(
            modifier = Modifier.fillMaxSize().background(ThemeColor.shared().defaultBakground)
                .padding(bottom = 20.dp)
        ) {
            TopNavBar(title = "Orders", NavigationParam(),onBackPress = {
                AppNavigator.shared().goBack()
            },)
            if (orders.value.isEmpty()) {
                EmptyData("No orders found", viewModel)
            }
            LazyVerticalGrid(
                columns = GridCells.Adaptive(minSize = 400.dp),
                modifier = Modifier.weight(1f).padding(
                    start = 0.dp,
                    end = 0.dp,
                    bottom = if (orders.value.isNotEmpty()) 0.dp else (60.dp)
                ),
            ) {
                items(orders.value.count()) { index ->
                    OrderBusinessCard(myBusiness.value,orders.value[index], businessViewModel) {

                    }
                }
            }
        }
    }
}